<div class="">
    <hvac-tab-bar>
        <button *ngFor="let tab of tabs"
                (click)="selectTab(tab.key)"
                [class.hvac-active]="selectedTab === tab.key">
        {{ tab.label }}
        </button>
    </hvac-tab-bar>
</div>

<div *ngIf="isLoading" class="hvac-layer-view-spinner">
    <utc-loading-spinner [spinnerSize]="'small'"></utc-loading-spinner>
</div>
<div class="tab-body">
    <hvac-layer-view-okta-data *ngIf="selectedTab === 'OKTA_DATA'" [oktaData]="oktaData" ></hvac-layer-view-okta-data>
    <hvac-layer-view-ldap-data *ngIf="selectedTab === 'LDAP_DATA'" [ldapData]="ldapData"></hvac-layer-view-ldap-data>
    <hvac-layer-view-mss-data *ngIf="selectedTab === 'MSS_DATA'" [mssData]="mssData"></hvac-layer-view-mss-data>
    <hvac-layer-view-hybris-data *ngIf="selectedTab === 'HYBRIS_DATA'" [hybrisData]="hybrisData"></hvac-layer-view-hybris-data>
</div>

<div class="hvac-divider"></div>

<div class="hvac-row hvac-account-admin-detail-footer hvac-flex-end">
    <button type="button" [hvacButton]="'default'" (click)="backFromLayerView()">
        <span>{{ "FOOTER.BACK_TO_PREVIOUS_STEP" | translate }}</span>
    </button>
</div>


